import React from "react";
import ModalWindow from "./ModalWindow";

/**
 * Reusable modal with standard "error-block/error-massage" layout.
 * `message` can be a string or a React node.
 * `actions` is typically one or more <button> elements.
 */
const ModalMessage = ({ title, message, actions }) => {
  return (
    <ModalWindow>
      <div className="error-block">
        <div className="error-massage">
          <h1>{title}</h1>
          {typeof message === "string" ? <p>{message}</p> : message}
          {actions}
        </div>
      </div>
    </ModalWindow>
  );
};

export default ModalMessage;

